<template>
  <div id="edit-vertragspartner-view">
    <h1 class="fs-2 mb-0" v-if="vertragspartner != null">Partner bearbeiten</h1>
    <h1 class="fs-2 mb-0" v-else>Neuer Partner</h1>

    <LoadingSpinner v-if="loading" />

    <div v-else>
      <form @submit.prevent="saveVertragspartner">
        <div class="row mx-0">
          <div class="col-4 p-2 ps-0">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <p><strong>Unternehmen</strong></p>
              <div class="mb-3">
                <label for="unternehmen" class="form-label">Unternehmen</label>
                <input type="text" class="form-control" id="unternehmen" v-model="editVertragspartner.unternehmen" />
              </div>

              <div>
                <label for="unternehmenzusatz" class="form-label">Unternehmenzusatz</label>
                <input type="text" class="form-control" id="unternehmenzusatz" v-model="editVertragspartner.unternehmenzusatz" />
              </div>

              <hr class="my-3" />

              <p><strong>Ansprechpartner</strong></p>

              <div class="row mx-0">
                <div class="col-2 p-0 pe-1">
                  <label for="anrede" class="form-label">Anrede</label>
                  <input type="text" class="form-control" id="anrede" v-model="editVertragspartner.anrede" />
                </div>

                <div class="col-5 p-0 px-1">
                  <label for="vorname" class="form-label">Vorname</label>
                  <input type="text" class="form-control" id="vorname" v-model="editVertragspartner.vorname" />
                </div>

                <div class="col-5 p-0 ps-1">
                  <label for="name" class="form-label">Name</label>
                  <input type="text" class="form-control" id="name" v-model="editVertragspartner.name" />
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 p-2">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <p><strong>Anschrift</strong></p>
              <div class="mb-3">
                <label for="strasse" class="form-label">Straße & Hausnummer</label>
                <input type="text" class="form-control" id="strasse" v-model="editVertragspartner.strasse" />
              </div>

              <div class="row mx-0 mb-3">
                <div class="col-4 p-0 pe-1">
                  <label for="plz" class="form-label">PLZ</label>
                  <input type="text" class="form-control" id="plz" v-model="editVertragspartner.plz" />
                </div>

                <div class="col-8 p-0 ps-1">
                  <label for="ort" class="form-label">Ort</label>
                  <input type="text" class="form-control" id="ort" v-model="editVertragspartner.ort" />
                </div>
              </div>

              <div class="mb-3">
                <label for="Land" class="form-label">Land</label>
                <input type="text" class="form-control" id="land" v-model="editVertragspartner.land" />
              </div>
            </div>
          </div>

          <div class="col-4 p-2 pe-0">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <p><strong>Info</strong></p>
              <div class="mb-3">
                <label for="notizen" class="form-label">Notizen</label>
                <textarea class="form-control" id="notizen" rows="14" v-model="editVertragspartner.notizen"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-0 mb-3">
          <div class="col-4 p-2 ps-0">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <p><strong>Einstellungen</strong></p>
              <div class="mb-3">
                <label for="tariefgebiet" class="form-label">Tarifgebiet</label>
                <input type="text" class="form-control" id="tariefgebiet" v-model="editVertragspartner.tarifgebiet" />
              </div>

              <div class="mb-3">
                <label for="standort" class="form-label">Standort</label>
                <input type="text" class="form-control" id="standort" v-model="editVertragspartner.standort" />
              </div>

              <div class="mb-3">
                <label for="hrbpStandard" class="form-label">HRBP Standard</label>
                <input type="text" class="form-control" id="hrbpStandard" v-model="editVertragspartner.hrbpStandard" />
              </div>

              <div>
                <label for="auVorlage" class="form-label">AU Vorlage</label>
                <input type="text" class="form-control" id="auVorlage" v-model="editVertragspartner.auVorlage" />
              </div>
            </div>
          </div>

          <div class="col-4 p-2">
            <div class="h-100">
              <nav>
                <div class="nav nav-tabs" id="nav-tabs" role="tablist">
                  <button
                    class="nav-link active fw-bold"
                    id="nav-tab-kf-de"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-kf-de"
                    type="button"
                    role="tab"
                    aria-controls="nav-kf-de"
                    aria-selected="true"
                  >
                    Deutsch
                  </button>

                  <button
                    class="nav-link fw-bold"
                    id="nav-tab-kf-en"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-kf-en"
                    type="button"
                    role="tab"
                    aria-controls="nav-kf-en"
                    aria-selected="true"
                  >
                    Englisch
                  </button>
                </div>
              </nav>

              <div class="tab-content bg-white shadow rounded-bottom border-start border-bottom border-end p-3" id="nav-content">
                <!-- Deutsch -->
                <div class="tab-pane p-2 fade show active" id="nav-kf-de" role="tabpanel" aria-labelledby="nav-tab-kf-de" tabindex="0">
                  <div class="mb-3">
                    <label for="kf-probezeit-de" class="form-label">Kündigungsfrist während der Probezeit</label>
                    <textarea class="form-control" id="kf-probezeit-de" rows="5" v-model="editVertragspartner.kfWaerendProbezeit"></textarea>
                  </div>

                  <div class="mb-3">
                    <label for="kf-probezeit-en" class="form-label">Kündigungsfrist nach der Probezeit</label>
                    <textarea class="form-control" id="kf-probezeit-en" rows="5" v-model="editVertragspartner.kfNachProbezeit"></textarea>
                  </div>
                </div>

                <!-- Englisch -->
                <div class="tab-pane p-2 fade" id="nav-kf-en" role="tabpanel" aria-labelledby="nav-tab-kf-en" tabindex="0">
                  <div class="mb-3">
                    <label for="kf-probezeit-en" class="form-label">Kündigungsfrist während der Probezeit</label>
                    <textarea class="form-control" id="kf-probezeit-en" rows="5" v-model="editVertragspartner.kfWaerendProbezeitEN"></textarea>
                  </div>

                  <div class="mb-3">
                    <label for="kf-probezeit-en" class="form-label">Kündigungsfrist nach der Probezeit</label>
                    <textarea class="form-control" id="kf-probezeit-en" rows="5" v-model="editVertragspartner.kfNachProbezeitEN"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 p-2 pe-0">
            <div class="bg-white shadow rounded p-3 pe-4 h-100">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <strong>Druckvorlagen</strong>

                <SelectDruckvorlagenModal
                  :vorlagen="editVertragspartner.druckvorlagen.map((d) => d.druckvorlageId)"
                  :druckvorlagen="druckvorlagen"
                  @set-selected-vorlagen="setSelectedVorlagen"
                />
              </div>

              <div v-if="editVertragspartner.druckvorlagen == undefined || editVertragspartner.druckvorlagen.length == 0">
                <em>Keine Druckvorlagen zugewiesen.</em>
              </div>
              <div v-else>
                <p v-for="vorlage in editVertragspartner.druckvorlagen" :key="vorlage.id">{{ getDruckvorlageName(vorlage.druckvorlageId) }}</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="errorMsg != ''" class="alert alert-danger">
          Es ist ein Fehler aufgetreten:
          {{ errorMsg }}
        </div>

        <div class="save-bar bg-white position-fixed bottom-0 end-0 p-3 w-100 shadow border-top d-flex justify-content-end">
          <button type="button" class="btn btn-secondary me-3" @click="cancel()">Abbrechen</button>
          <button type="submit" class="btn btn-primary">Speichern</button>
        </div>
      </form>

      <div v-if="vertragspartner != null">
        <button type="button" class="btn btn-danger" @click="deleteVertragspartner()"><font-awesome-icon icon="trash" /> Vertragspartner löschen</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, PropType, onMounted } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';

  import { ActionTypes as VertragspartnerActionTypes } from '@/store/modules/Vertragspartner/actions';
  import { ActionTypes as DruckvorlageActionTypes } from '@/store/modules/Druckvorlagen/actions';

  import { Vertragspartner, VertragspartnerDruckvorlage } from '@/models/VertragspartnerModels';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import SelectDruckvorlagenModal from '@/components/Vertragspartner/SelectDruckvorlagenModal.vue';
  //#endregion

  const props = defineProps({
    vertragspartnerid: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const store = useStore();
  const router = useRouter();

  const loading = computed(
    () =>
      store.getters.status.createVertragspartnerLoading ||
      store.getters.status.updateVertragspartnerLoading ||
      store.getters.status.deleteVertragspartnerLoading
  );
  const errorMsg = computed(() => store.getters.status.vertragspartnerErrorMsg);

  const vertragspartner = computed(() => store.getters.vertragspartner.find((v: Vertragspartner) => v.id == parseInt(props.vertragspartnerid)));
  const editVertragspartner = ref(
    vertragspartner.value != null ? (JSON.parse(JSON.stringify(vertragspartner.value)) as Vertragspartner) : new Vertragspartner()
  );

  function saveVertragspartner() {
    if (vertragspartner.value != null) {
      store.dispatch(VertragspartnerActionTypes.UpdateVertragspartner, editVertragspartner.value).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'DetailsVertragspartner', query: { vertragspartnerid: props.vertragspartnerid } });
        }
      });
    } else {
      store.dispatch(VertragspartnerActionTypes.CreateVertragspartner, editVertragspartner.value).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'Vertragspartner' });
        }
      });
    }
  }

  function deleteVertragspartner() {
    if (vertragspartner.value != null) {
      store.dispatch(VertragspartnerActionTypes.DeleteVertragspartner, vertragspartner.value.id).then(() => {
        if (errorMsg.value == '') {
          router.push({ name: 'Vertragspartner' });
        }
      });
    }
  }

  const druckvorlagen = computed(() => store.getters.druckvorlagen);

  function getDruckvorlageName(id: number): string {
    const druckvorlage = druckvorlagen.value.find((d: any) => d.id == id);
    return druckvorlage != null ? druckvorlage.titel : 'Unbekannte Druckvorlage';
  }

  function setSelectedVorlagen(data: Array<number>) {
    editVertragspartner.value.druckvorlagen = new Array<VertragspartnerDruckvorlage>();
    for (var value of data) {
      const druckvorlage = druckvorlagen.value.find((d: any) => d.id == value);
      if (druckvorlage != null) {
        const newValue = new VertragspartnerDruckvorlage();
        newValue.vertragspartnerId = editVertragspartner.value.id;
        newValue.druckvorlageId = druckvorlage.id;
        editVertragspartner.value.druckvorlagen.push(newValue);
      }
    }

    // if (updateArtikel.variants.length > 0) {
    //   for (var variante of newArtikel.variants) {
    //     variante.articleTags = newArtikel.article.articleTags;
    //   }
    // }
  }

  function cancel() {
    router.back();
  }

  onMounted(async () => {
    if (druckvorlagen.value.length == 0) {
      await store.dispatch(DruckvorlageActionTypes.GetDruckvorlagen, undefined);
    }
  });
</script>

<style scoped>
  .save-bar {
    z-index: 1;
  }

  #edit-vertragspartner-view {
    margin-bottom: 70px;
  }
</style>
